import React, { FC, useState } from 'react';
import AuthForm from './AuthForm';
import { DialogTitle } from './CustomDialogTitle';
import {
  Dialog,
  DialogContent,
  Button,
  IconButton,
  MenuItem,
  useMediaQuery,
  ListItemIcon,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import VoteCaret from './VoteCaret';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Capacitor } from '@capacitor/core';

interface AuthFormModalProps {
  closeMobileMenu?: () => void;
  type?: 'upvote' | 'downvote' | 'default';
}

const AuthFormModal: FC<AuthFormModalProps> = ({ closeMobileMenu, type = 'default' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) || Capacitor.getPlatform() !== 'web';
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMobileMenu = () => {
    handleClickOpen();
    if (closeMobileMenu) {
      closeMobileMenu();
    }
  };

  return (
    <div>
      {type === 'upvote' ? (
        <IconButton
          onClick={handleClickOpen}
          size="small"
          sx={{ p: 0.5, borderRadius: 'var(--radius-image)' }}
        >
          <VoteCaret dir="up" color={theme.tokens.colors.text4} size={isMobile ? 17 : 18} />
        </IconButton>
      ) : type === 'downvote' ? (
        <IconButton
          onClick={handleClickOpen}
          size="small"
          sx={{ p: 0.5, borderRadius: 'var(--radius-image)' }}
        >
          <VoteCaret dir="down" color={theme.tokens.colors.text4} size={isMobile ? 17 : 18} />
        </IconButton>
      ) : isMobile ? (
        <MenuItem onClick={handleMobileMenu}>
          <ListItemIcon>
            <ExitToAppIcon style={{ marginRight: 'var(--space-icon-gap)' }} />
            Login/Register
          </ListItemIcon>
        </MenuItem>
      ) : (
        <Button
          color="primary"
          onClick={handleClickOpen}
          sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
        >
          Login/Register
        </Button>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        PaperProps={{ sx: { p: 0, overflow: 'hidden' } }}
      >
        <DialogTitle onClose={handleClose} />
        <DialogContent>
          <AuthForm onClose={handleClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AuthFormModal;
